import * as ActionType from 'constants/action-types/organization';

export default (state, { type, payload }) => {
  switch (type) {
    case ActionType.DELETE_BULK_PAYMENT_OPERATION_START:
      return {
        ...state,
        deleteOperation: {
          ...state.deleteOperation,
          loading: true,
          error: null,
        },
      };
    case ActionType.DELETE_BULK_PAYMENT_OPERATION_SUCCESS:
      return {
        ...state,
        deleteOperation: {
          ...state.deleteOperation,
          data: payload,
          error: null,
          loading: false,
        },
      };
    case ActionType.DELETE_BULK_PAYMENT_OPERATION_ERROR:
      return {
        ...state,
        deleteOperation: {
          ...state.deleteOperation,
          data: payload,
          error: null,
          loading: false,
        },
      };

    case ActionType.CLEAR_DELETE_BULK_PAYMENT_OPERATION_STORE:
      return {
        ...state,
        deleteOperation: {
          ...state.deleteOperation,
          error: null,
          loading: false,
          data: null,
        },
      };

    default:
      return null;
  }
};
